import { InjectionToken } from "@angular/core";
import { Observable } from "rxjs";

export interface IAuthService {
    onLoginEvent$: Observable<void>;
    onLogoutEvent$: Observable<void>;
    onDisconnectEvent$: Observable<void>;

    isLoggedIn(): boolean;
    logOut(): void;
    init(): void;
}

export const AuthService = new InjectionToken<IAuthService>("Auth");
